import styled from 'styled-components'
import { Row } from '@hfs/ui/components/Row'

export const PageWrapper = styled(Row)`
  position: relative;
`
